import { render, staticRenderFns } from "./CourceModels.vue?vue&type=template&id=17275ac6&scoped=true"
import script from "./CourceModels.vue?vue&type=script&lang=js"
export * from "./CourceModels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17275ac6",
  null
  
)

export default component.exports